<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>活动设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 30%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            show-checkbox
            @check="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div style="rgb(222,222,222);width: 80%;height: 600px;">
        <el-button size="mini" v-if="authorities.includes('system.active.new')" @click="showActiveDialog">新建活动</el-button>
        <el-button size="mini" v-if="authorities.includes('system.active.set')" @click="createOrgActivity">机构配置活动</el-button>
        <el-card style="height: 550px;">
          <el-checkbox-group v-model="orgActivity.activityIds" size="small">
            <el-checkbox v-for="(activity,index) in activityList"
                         :label="activity.id"
                         :key="index">
              {{activity.activityName}}
            </el-checkbox>
          </el-checkbox-group>
        </el-card>
        <br>
      </div>
    </div>

    <el-dialog
      title="新建活动"
      :visible.sync="activeDialogVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="display: flex;justify-content: flex-start;align-items: center;margin-top: 20px">
        <span>活动名称：</span>
        <el-input size="mini" v-model="activity.activityName" style="width: 90%"/>
      </div>
      <div style="display: flex;justify-content: space-around;align-items: center;margin-top: 20px">
        <span>充值金额：</span>
        <el-input size="mini" v-model="activity.money" style="width: 40%" onkeyup="value=value.replace(/[^\d.]/g,'')"/>

        <span>赠送金额：</span>
        <el-input size="mini" v-model="activity.giveMoney" style="width: 40%" onkeyup="value=value.replace(/[^\d.]/g,'')"/>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="closeActiveDialog">取 消</el-button>
          <el-button size="mini" @click="createActivity">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgList: [],
      filterText: '',
      authorities:'',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      activeDialogVisible:false,
      activity:{
        activityName:'',
        money:'',
        giveMoney:'',
        creator:''
      },
      activityList:[],
      orgActivity:{
        orgIds:[],
        activityIds:[],
      }

    }
  },
  methods:{
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //组织机构树点击节点方法
    handleCheckChange(data) {
      this.selectOrgId = data.id;
      this.loadOrgActivity();
    },
    async loadOrgActivity(){
      const {data:res} = await this.$http.get(`/activity/ids/orgId/${this.selectOrgId}`);
      this.orgActivity.activityIds = res.data;
    },
    showActiveDialog(){
      this.activeDialogVisible = true;
    },
    closeActiveDialog(){
      this.activeDialogVisible = false;
    },
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    async loadActivityList(){
      const {data:res} = await this.$http.get(`/activity/selectAll`);
      this.activityList = res.data;
    },
    async createActivity(){
      this.activity.creator = this.userId;
      const {data:res} = await this.$http.post(`/activity/add`, this.activity);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadActivityList();
      this.closeActiveDialog();
    },
    async createOrgActivity(){
      this.orgActivity.orgIds = this.$refs.tree.getCheckedKeys();
      if (this.orgActivity.orgIds.length === 0){
        return this.$message.warning("请选择机构！")
      }
      const {data:res} = await this.$http.post(`/activity/org/addActivity`, this.orgActivity);
      await this.loadOrgActivity();
      if (res.code === 200){
        this.$message.success("操作成功！");
      }

    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
    this.loadActivityList();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
//align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
//display: flex;
//justify-content: start;
  height: 100%;
  overflow-y: auto;
//flex: 1;
  width: 30%;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
//flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
}
/deep/ td {
  padding: 2px ;
}
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
.el-dialog__title{
  color: #333;
}
.el-dialog__close{
  color: #333 !important;
}
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Activity.vue